module.exports = __webpack_public_path__ + "img/vcf.d1694eec.svg";